<template>
  <LayoutBasic :showLinksMenu="false">
    <template v-slot:navigation-title>Integraciones</template>
    <template v-slot:vista-previa>
      <router-view />
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from '@/layouts/LayoutBasic.vue'

export default {
  name: 'IntegracionesLayout',
  components: { LayoutBasic }
}
</script>
